import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './Quiz.scss';

function toggleFullscreen(image) {
  if (!document.fullscreenElement) {
    image.requestFullscreen().catch(err => {
      console.error(`Error attempting to enable fullscreen mode: ${err.message}`);
    });
  } else {
    document.exitFullscreen().catch(err => {
      console.error(`Error attempting to exit fullscreen mode: ${err.message}`);
    });
  }
}

function Quiz() {
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null); // TODO: Is state necessarry?
  const startTimeRef = useRef(null);

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_URL + '/questions?quiz=dv');
      response.data.questions.forEach((question, index) => {
        question.index = index + 1; // Add the index starting from 1
        question.total = response.data.questions.length; // Add the total number of questions
      });
      setQuestions(response.data.questions);
      startTimeRef.current = performance.now();
    } catch (error) {
      console.error('Error fetching questions:', error);
    }
  };

  const fetchResult = async () => {
    try {
      const endTime = performance.now();
      const timeElapsed = endTime - startTimeRef.current;
      startTimeRef.current = null;
      const response = await axios.post(process.env.REACT_APP_BACKEND_URL + '/answers', { "quiz": "dv","answers": answers });
      response.data.result.time = (timeElapsed / 1000).toFixed(3);
      setResult(response.data.result);
    } catch (error) {
      console.error('Error fetching result:', error);
    }
  }

  const handleSubmitAnswer = async (selectedAnswer) => {
    console.log('Selected Answer:', selectedAnswer);
    answers.push({
      "code": questions[currentQuestionIndex].code,
      "selected": selectedAnswer
    });
    setAnswers(answers);
    if (answers.length === questions.length) {
      await fetchResult();
      // TODO: Handle result more nicely instead of incrementing question index and checking
    }
    const nextQuestionIndex = currentQuestionIndex + 1;
    setCurrentQuestionIndex(nextQuestionIndex);
  };

  const handleRestart = async () => {
    await fetchQuestions();
    setAnswers([]);
    setResult(null);
    setCurrentQuestionIndex(0);
  }

  if (questions.length === 0) {
    return <div>Loading...</div>;
  }

  // {currentQuestionIndex < questions.length ?

  return (
    <div class="app-container d-flex flex-column">
      <NavBar />
      {currentQuestionIndex < questions.length ?
        <Question question={questions[currentQuestionIndex]} answerCallback={handleSubmitAnswer} />
        : <Result resultData={result} restartCallback={handleRestart} />}

      <Disclaimer />
    </div >

  )
}

const todoReplace = () => {
  alert('Settings clicked!');
};

function NavBar() {
  return (
    <nav class="navbar navbar-dark bg-dark text-light w-100">
      <div class="container-fluid d-flex justify-content-center position-relative">
        <span class="navbar-brand mb-0 h1">
          {process.env.REACT_APP_TITLE}
        </span>

        <div
          onClick={todoReplace}
          className="position-absolute end-0 me-3 cursor-pointer"
          role="button"
        >
          <i className="fas fa-cog fa-lg"></i>
        </div>
      </div>
    </nav>
  );
}

// “[Title of your Fan Content] is unofficial Fan Content permitted under the Fan Content Policy. Not approved/endorsed by Wizards. Portions of the materials used are property of Wizards of the Coast. ©Wizards of the Coast LLC.”

function Disclaimer() {
  return (
    <footer class="app-footer bg-dark text-light text-center p-2">
      <small>{process.env.REACT_APP_FOOTER}</small>
    </footer>
  );
}

function Question({ question, answerCallback }) {
  return (
    <main class="container d-flex flex-grow-1 flex-column align-items-center justify-content-center  overflow-hidden">
      <div
        class="quiz-container h-100 p-3 d-flex flex-column align-items-center"
      >
        <div class="ratio-25x35 h-65 p-2">
          <div class="question-container p-2 h-100 d-flex flex-column align-items-center card border border-2 rounded-4">
            <div class="question-header d-flex justify-content-between align-items-center w-100">
              <div class="progress-tracker fw-bold">{question.index}/{question.total}</div>
              <div class="tags-container d-flex gap-2">
                <div className={`tag-difficulty difficulty-${question.difficulty} badge rounded-pill`}>{question.difficulty}</div>
                <div class="tag-type badge rounded-pill text-bg-dark">{question.type}</div>
              </div>
            </div>

            {question.images && question.images.length > 0 ? (
              <><div className="question-image-container align-items-center flex-grow-1 justify-content-center g-2 d-flex">
                {question.images.map((img, index) => (
                  <div class="image-container p-2">
                    <img class="w-100" key={index} src={img} alt={`Question ${question.index}`} role="button" onClick={(e) => toggleFullscreen(e.target)} />
                  </div>
                ))}
              </div>
                <div class="question-text text-center fw-bold fs-5">
                  {question.text.split(/\s+/).map(word => {
                    if (word.startsWith("{")) {
                      let classNames = 'symbol ' + word.substring(1);
                      return <i class={classNames}></i>;
                    } else {
                      return word + " ";
                    }
                  })}
                </div></>
            ) : <div class="question-text text-center fw-bold fs-5 flex-grow-1 d-flex align-items-center">
              {question.text.split(/}| /).map(word => {
                if (word.startsWith("{")) {
                  let classNames = 'symbol ' + word.substring(1);
                  return <i class={classNames}></i>;
                } else {
                  return word + " ";
                }
              })}
            </div>}
          </div>
        </div>
        <div class="answer-container p-2 h-35 ratio-65x49">
          <div
            className="answer-container answer-grid d-grid gap-3 h-100"
          >
            {question.options.map((option, index) => (
              <button
                key={index}
                onClick={() => answerCallback(option)}
                className="btn btn-primary answer-button"
                style={{
                  fontSize: '1.2rem',
                  padding: '1rem',
                  borderRadius: '8px',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                }}
              >
                {option}
              </button>
            ))}
          </div>



        </div>
      </div>
    </main>
  );
}

const resultTitles = [
  "TODO: Title for scoring 0/10",
  "TODO: Title for scoring 1/10",
  "TODO: Title for scoring 2/10",
  "TODO: Title for scoring 3/10",
  "TODO: Title for scoring 4/10",
  "TODO: Title for scoring 5/10",
  "TODO: Title for scoring 6/10",
  "TODO: Title for scoring 7/10",
  "TODO: Title for scoring 8/10",
  "TODO: Title for scoring 9/10",
  "TODO: Title for scoring 10/10",
]

function Result({ resultData, restartCallback }) {

  const reportQuestion = () => {
    alert("Reporting questions is currently WIP");
  }
  return (
    <main class="container d-flex flex-grow-1 flex-column align-items-center justify-content-center">
      <div class="ratio-9x16 h-50">
        <div class="result-container h-100 card border border-2 rounded-4 d-flex flex-column align-items-center">
          <div class="result-score flex-grow-1 text-center d-flex align-items-center">{resultData.score}/{resultData.total}</div>
          <div class="result-title">{resultTitles[resultData.score]}</div>
          <div class="result-time">Time: {resultData.time} seconds</div>
        </div>
      </div>
      <div class="restart-container">
        <button
          onClick={() => restartCallback()}
          className="btn btn-primary restart-button"
          style={{
            fontSize: '1.2rem',
            padding: '1rem',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >Restart</button>
      </div>
      <div class="solution-container accordion" id="accordionExample">
        {resultData.questions.map((question, index) => (
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button
                class={`accordion-button collapsed ${question.selected === question.answer ? 'bg-success' : 'bg-danger'}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={"#collapse" + index}
                aria-expanded="false"
                aria-controls={"collapse" + index}
              >
                Q{index + 1} {question.text}
              </button>
            </h2>
            <div id={"collapse" + index} class="accordion-collapse collapse">
              <div class={`accordion-body ${question.selected === question.answer ? 'bg-success-subtle' : 'bg-danger-subtle'} d-flex flex-row`}>
                <div class="explanation-container flex-grow-1">
                  <div className="solution-image-container align-items-center justify-content-start d-flex">
                    {question.images.map((img, index) => (
                      <div class="image-container">
                        <img key={index} src={img} alt={`Question ${question.index}`} role="button" onClick={(e) => toggleFullscreen(e.target)} class="img-fluid" style={{ maxHeight: '10em' }} />
                      </div>
                    ))}
                  </div>
                  {"Solution: " + question.answer}
                  {question.selected !== question.answer && (
                    <>
                      <br />
                      {"Your answer: " + question.selected}
                    </>
                  )}
                  <br /><br />
                  {question.solution}
                </div>
                <div class="report-question d-flex align-items-end" role="button" onClick={() => reportQuestion()}>
                  <i class="fas fa-exclamation-triangle"></i>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}

export default Quiz;
